import Vue from "vue"
import VueRouter, {
  RouteConfig
} from "vue-router"
import Main from './main.js'
Vue.use(VueRouter)

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...Main
  ]
})
router.beforeEach(async (to, from, next) => {
  if (to.path) {
     if (window._hmt) {
          window._hmt.push(['_trackPageview', '/#' + to.fullPath]);
      }
  }
  next(); 
}); 

// 处理vue-router.esm.js?8c4f:2089 Uncaught (in promise) 的发生
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router